module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_2",
      "title": "[Pg 2]"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "Second_Day"
    }
  }, [_vm._v("Second Day.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "calibre10"
  }, [_c('img', {
    staticClass: "drop-cap",
    attrs: {
      "alt": "",
      "id": "id-4105359371250540193",
      "src": "Images/img0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pcalibre verse"
  }, [_vm._v("Show me the man who says")]), _vm._v(" "), _c('div', {
    staticClass: "verse1"
  }, [_vm._v("anything against women,")]), _vm._v(" "), _c('div', {
    staticClass: "verse5"
  }, [_vm._v("as women, and I boldly declare,")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_vm._v("he is not a man.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Pickwick.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Natural affection and instinct are the")]), _vm._v(" "), _c('div', {
    staticClass: "verse6"
  }, [_vm._v("most beautiful")]), _vm._v(" "), _c('div', {
    staticClass: "verse1"
  }, [_vm._v("of the Almighty’s works.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Charles Cheeryble.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse5"
  }, [_vm._v("It must be somewhere written that the")]), _vm._v(" "), _c('div', {
    staticClass: "verse4"
  }, [_vm._v("virtues of the mothers")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("shall occasionally be visited on the children,")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_vm._v("as well as the sins of their fathers.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Mr. Jarndyce.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("We can all do some good, if we will.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Dickens.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0